import Lottie from 'lottie-react';

import json from '../jsons/fireworks-loop-burst.json';

const FireWorks = props => {
  return <Lottie loop={false} animationData={json} {...props} />;
};

export default FireWorks;
